import toast from 'react-hot-toast'
import {MediaViewer} from '../../utils/components/MediaViewer'
import {downloadFile} from '../../utils/helperFunction/_helper'
import {KTIcon} from '../../../_metronic/helpers'

type Props = {
  previewUrl: string
  file: File | null
}

const PreviewImage = ({previewUrl, file}: Props) => {
  const onDownloadFile = () => {
    if (!file) return
    toast.loading('Processing..')
    previewUrl && downloadFile(file, file.name)

    toast.dismiss()
  }

  if (!previewUrl || !file) {
    return null
  }

  return (
    <div className='d-flex align-items-start gap-3'>
      <MediaViewer media={previewUrl} classname='w-100px h-100px' />
      <div>
        <div>
          <span className='fs-6 fw-semibold'>{file?.name}</span>
          <br />
          <span className='fs-6'>{Math.floor(file?.size / 1024)} KB</span>
        </div>

        <div role='button' className='mt-10' onClick={() => onDownloadFile()}>
          <KTIcon iconName='file-down' className='fs-1 text-info text-hover-primary' />
        </div>
      </div>
    </div>
  )
}

export default PreviewImage
